import React from 'react'
import Image from 'next/image'

type RatingStarType = {
    rating: number | 0
}

const RatingStar: React.FC<RatingStarType> = ({ rating }) => {
    return (
        <div className='flex gap-1'>
            {Array.from({length: rating || 0}, (v, i) => (
                <Image 
                    key={i}
                    src={'/assets/icons/star-fill.svg'} 
                    alt='Star' 
                    height={8} 
                    width={8} 
                    sizes='100vw'
                    style={{
                        width: '20%',
                        height: 'auto'
                    }} 
                />
            ))}
            {Array.from({length: (5 - rating) || 0}, (v, i) => (
                <Image 
                    key={i}
                    src={'/assets/icons/star-unfill.svg'} 
                    alt='Star' 
                    height={8} 
                    width={8} 
                    sizes='100vw'
                    style={{
                        width: '20%',
                        height: 'auto'
                    }} 
                />
            ))}
        </div>
    )
}

export default RatingStar